import { render, staticRenderFns } from "./WaitlistCard.vue?vue&type=template&id=5e2306be&"
import script from "./WaitlistCard.vue?vue&type=script&lang=js&"
export * from "./WaitlistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports